module.exports = __webpack_public_path__ + "img/refresh.b37b94cc.svg";